import React from 'react';
import { motion } from 'framer-motion';
import { FaDownload, FaUser, FaCode, FaHeart } from 'react-icons/fa';
import resume from './image/divyanshi tiwari resume updated).pdf';
import './About.css';

const About = () => {
  const stats = [
    { icon: FaUser, number: '3+', label: 'Years Experience' },
    { icon: FaCode, number: '25+', label: 'Projects Completed' },
    { icon: FaHeart, number: '100%', label: 'Client Satisfaction' }
  ];

  const skills = [
    'React.js',  'JavaScript', 'Material UI', 'HTML5', 'CSS3', 'Tailwind CSS', 'Angular', 'TypeScript','Node.js',
     'MongoDB', 'PostgreSQL', 'GitHub', 'Azure'
  ];

  const handleResumeDownload = () => {
    const link = document.createElement('a');
    link.href = resume;
    link.download = 'Divyanshi_Tiwari_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="about" className="about section">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          About Me
        </motion.h2>
        
        <motion.p
          className="section-subtitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Passionate developer with a love for creating innovative solutions and beautiful user experiences
        </motion.p>

        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <h3>Who I Am</h3>
            <p>
              I'm Divyanshi, a passionate Frontend Developer with over 3 years of experience in creating 
              web applications and digital solutions. I specialize in modern web technologies 
              and love turning complex problems into simple, beautiful, and intuitive designs.
            </p>
            
            <p>
              When I'm not coding, you can find me exploring new technologies, contributing to 
              open-source projects, or sharing knowledge with the developer community. I believe 
              in writing clean, maintainable code and creating user experiences that make a difference.
            </p>

            <div className="about-skills">
              <h4>Technologies I work with:</h4>
              <div className="skills-tags">
                {skills.map((skill, index) => (
                  <motion.span
                    key={skill}
                    className="skill-tag"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.5 + index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    {skill}
                  </motion.span>
                ))}
              </div>
            </div>

            <motion.button
              className="btn btn-primary"
              onClick={handleResumeDownload}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaDownload /> Download Resume
            </motion.button>
          </motion.div>

          <motion.div
            className="about-stats"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <div className="stats-grid">
              {stats.map((stat, index) => (
                <motion.div
                  key={stat.label}
                  className="stat-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.6 + index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.05 }}
                >
                  <div className="stat-icon">
                    <stat.icon />
                  </div>
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About; 